import ThreeDotsLoader from "@/components/common/three-dots-loader";
import { ContentLayoutProps } from "./types";
import { EmptyState } from "./EmptyState";

export function ContentLayout({
  header,
  data,
  isLoading,
  isFetching,
  error,
  children,
  emptyState,
  errorMessage = "Failed to load data",
  loader = <ThreeDotsLoader />,
  containerClassName = "h-full p-6 w-full",
  headerClassName = "space-y-4",
  contentClassName = "space-y-6 mt-6"
}: ContentLayoutProps) {
  
  return (
    <div className={containerClassName}>
      {/* Header Section - ALWAYS visible */}
      {header && (
        <div className={headerClassName}>
          {header}
        </div>
      )}

      {/* Content Section - Conditional rendering based on state */}
      <div className={contentClassName}>
        {error ? (
          <div className="text-center py-8 text-red-600">
            {errorMessage}
          </div>
        ) : (isFetching || isLoading) ? (
          <div className="flex justify-center items-center w-full min-h-[400px]">
            {loader}
          </div>
        ) : !data || (Array.isArray(data) && data.length === 0) ? (
          <EmptyState {...emptyState} />
        ) : (
          children
        )}
      </div>
    </div>
  );
}

// Export types for convenience
export type { ContentLayoutProps } from "./types";

